module.exports = __webpack_public_path__ + "assets/img/buy-gift-btn-155a1f37.png";